import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { GuardedProLinkClick } from '../../BotBuilderSidebar';
import { SidebarMenuDefinition } from '../../sidebar-menu';
import './SidebarMenuItem.scss';
import { trackWebAppGAEvent } from '../../../../common/helpers/plugins/website-google-analytics';

type Props = {
  menuItem: SidebarMenuDefinition;
  guardedProLinkClick: GuardedProLinkClick;
  baseUrl: string;
  isActive: boolean;
  onMobileClick?: () => any;
};

const SidebarMenuItem = (props: Props) => {
  const { menuItem, guardedProLinkClick, baseUrl, isActive, onMobileClick } =
    props;

  const linkUrl = baseUrl + menuItem.url;

  const classList = classnames('sidebar-menu-item', {
    'sidebar-menu-item--active': isActive,
  });

  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackWebAppGAEvent('click', {
      category: 'navigation',
      label: `navbar_link_${menuItem.name.toLocaleLowerCase()}`,
    });
    guardedProLinkClick(e, menuItem);

    if (onMobileClick) {
      onMobileClick();
    }
  };

  return (
    <div className={classList}>
      <div className="sidebar-menu-item__color-blinder" />

      <Link onClick={onClick} to={linkUrl} className="sidebar-menu-item__link">
        {menuItem.name}
      </Link>
    </div>
  );
};

export default SidebarMenuItem;
